/* eslint-disable security/detect-object-injection */
/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-unresolved */
// import { useState } from "react";
import CustomStepper from "src/shared/CustomStepper";
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import CustomBackDrop from "src/shared/CustomBackDrop";
import GeneralDetails from "./GeneralDetails";
import ProposerDetails from "./ProposerDetails";
import Review from "./Review";
// import PaymentDetails from "./PaymentDetails";
// import Stepper from "../../shared/Stepper";
// import JointLifeAddendum from "./JointLifeAddendum";
import LoanDetails from "./LoanDetails";
import JointLife from "./JointLife";
import AssignmentClauseDetails from "./AssignmentClauseDetails";

function FormDetails() {
  const isJointAddendumState = useAppSelector((state: any) => state.isJointAddendum.isJointState);
  const parentStepNumber = useAppSelector((state): any => state.stepDetails.parentStepNo);
  const isPostMEFLoading = useAppSelector((state): any => state.common.isPostMEFLoading);
  const assignmentNotice = useAppSelector((state) => state?.common?.assignmentStepperFlag);

  const steps = [
    {
      label: "General Details",
      enable: true,
      component: <GeneralDetails />
    },
    {
      label: "Proposer Details",
      enable: true,
      component: <ProposerDetails />
    },
    {
      label: "Joint Life Addendum",
      enable: !!(isJointAddendumState === "yes"),
      component: <JointLife />
    },
    {
      label: "Loan Details",
      enable: true,
      component: <LoanDetails />
    },
    {
      label: "Assignment Notice",
      enable: !!assignmentNotice,
      component: <AssignmentClauseDetails />
    },
    {
      label: "Review",
      enable: true,
      component: <Review />
    }
  ];

  return (
    <div>
      <CustomBackDrop open={isPostMEFLoading} />
      <CustomStepper
        steps={steps?.filter((ele) => ele?.enable)?.map((ele) => ele.label)}
        currentStep={parentStepNumber}
        stepperValue="parent"
        // setStepNo={setStepNo}
        showBackArrow={parentStepNumber !== 1}
        leftSpacingClasses="w-155/1000"
        rightSpacingClasses="w-155/1000"
        circleSizeClasses="h-8 w-8"
      />

      <div>
        <div>{steps?.filter((ele) => ele?.enable)?.[parentStepNumber - 1]?.component}</div>
      </div>
    </div>
  );
}

export default FormDetails;
